import { render, staticRenderFns } from "./PSector.vue?vue&type=template&id=e0c58b40&"
import script from "./PSector.vue?vue&type=script&lang=ts&"
export * from "./PSector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports